import type { FieldInputType } from '@lighthouse/core'
import React from 'react'

import BaseInput from '../BaseInput'
import type { FieldInputConfig } from '../types'
import { CheckboxField } from './CheckboxField'
import { SliderField } from './SliderField'

interface EmptyFieldProps {
    type: FieldInputType
    config?: FieldInputConfig
}

const EmptyField: React.FunctionComponent<EmptyFieldProps> = ({ type, config }) => {
    if (type === 'checkbox' && config) {
        return <CheckboxField id="empty" config={config} readOnly />
    }
    if (type === 'slider' && config?.inputType === 'slider') {
        return <SliderField id="empty" sliderConfig={config} config={config} readOnly />
    }
    return <BaseInput value="-" readOnly style={{ borderRadius: 6 }} />
}

export default EmptyField
